"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGreenLight = createGreenLight;
const events_1 = require("../../../events");
const greenLight_1 = require("../../../forms/ltx/greenLight");
const queries_1 = require("../queries");
const messages = {
    greenLight: {
        id: "dashboard.green_light",
        defaultMessage: "Zöld fény"
    },
    liverSize: {
        id: "dashboard.green_light.liver_size",
        defaultMessage: "Máj mérete"
    },
    caudateLobe: {
        id: "dashboard.green_light.caudate_lobe",
        defaultMessage: "Lobus caudatus"
    },
    portalCirculation: {
        id: "dashboard.green_light.portal_circulation",
        defaultMessage: "Portalis keringés"
    },
    portalVeinThrombosisGrade: {
        id: "dashboard.green_light.portal_vein_thrombosis_grade",
        defaultMessage: "Vena portae trombózis fokozata"
    },
    portalVeinThrombosisComment: {
        id: "dashboard.green_light.portal_vein_thrombosis_comment",
        defaultMessage: "Vena portae trombózis megjegyzés"
    },
    arterialSupply: {
        id: "dashboard.green_light.arterial_supply",
        defaultMessage: "Arteriás vérellátás"
    },
    hepaticArterialAnatomyType: {
        id: "dashboard.green_light.hepatic_arterial_anatomy_type",
        defaultMessage: "Arteria hepatica anatómia típusa"
    },
    hepaticArterialAnatomyComment: {
        id: "dashboard.green_light.hepatic_arterial_anatomy_comment",
        defaultMessage: "Arteria hepatica anatómia megjegyzés"
    },
    splenicArteryAneurysm: {
        id: "dashboard.green_light.splenic_artery_aneurysm",
        defaultMessage: "Arteria lienalis aneurysma"
    },
    arterialPressureMonitoringPlanned: {
        id: "dashboard.green_light.arterial_pressure_monitoring_planned",
        defaultMessage: "Artériás nyomásmérés (tervezetten)"
    },
    arterialConduitPlanned: {
        id: "dashboard.green_light.arterial_conduit_planned",
        defaultMessage: "Arteria conduit (tervezetten)"
    },
    estimatedBloodLoss: {
        id: "dashboard.green_light.estimated_blood_loss",
        defaultMessage: "Várható vérveszteség"
    },
    cellSaverUsePlanned: {
        id: "dashboard.green_light.cell_saver_use_planned",
        defaultMessage: "CellSaver (tervezetten)"
    },
    venoVenousBypass: {
        id: "dashboard.green_light.veno_venous_bypass",
        defaultMessage: "Veno-venosus bypass"
    },
    backupRecipient: {
        id: "dashboard.green_light.backup_recipient",
        defaultMessage: "Tartalék recipiens behívandó?"
    },
    immunosuppression: {
        id: "dashboard.green_light.immunosuppression",
        defaultMessage: "Immunszuppresszió"
    },
    immunosuppressionOther: {
        id: "dashboard.green_light.immunosuppression_other",
        defaultMessage: "Egyéb immunszuppresszió"
    },
    otherTechnicalDifficulties: {
        id: "dashboard.green_light.other_technical_difficulties",
        defaultMessage: "Egyéb technikai nehézségek (műtétek)"
    }
};
function createGreenLight({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.greenLight);
    if (event === undefined) {
        return undefined;
    }
    const items = [
        {
            type: "list-item",
            label: formatMessage(messages.liverSize),
            value: formatMessageMap(greenLight_1.liverSizeMessages, event.value.liverSize)
        },
        {
            type: "list-item",
            label: formatMessage(messages.caudateLobe),
            value: formatMessageMap(greenLight_1.caudateLobeMessages, event.value.caudateLobe)
        },
        {
            type: "list-item",
            label: formatMessage(messages.portalCirculation),
            value: formatMessageMap(greenLight_1.portalCirculationMessages, event.value.portalCirculation)
        },
        {
            type: "list-item",
            label: formatMessage(messages.portalVeinThrombosisGrade),
            value: formatMessageMap(greenLight_1.portalVeinThrombosisGradeMessages, event.value.portalVeinThrombosisGrade)
        },
        {
            type: "list-item",
            label: formatMessage(messages.arterialSupply),
            value: formatMessageMap(greenLight_1.arterialSupplyMessages, event.value.arterialSupply)
        },
        {
            type: "list-item",
            label: formatMessage(messages.hepaticArterialAnatomyType),
            value: formatMessageMap(greenLight_1.hepaticArterialAnatomyTypeMessages, event.value.hepaticArterialAnatomyType)
        },
        {
            type: "list-item",
            label: formatMessage(messages.splenicArteryAneurysm),
            value: formatMessageMap(greenLight_1.splenicArteryAneurysmMessages, event.value.splenicArteryAneurysm)
        },
        {
            type: "list-item",
            label: formatMessage(messages.arterialPressureMonitoringPlanned),
            value: formatMessageMap(greenLight_1.arterialPressureMonitoringPlannedMessages, event.value.arterialPressureMonitoringPlanned)
        },
        {
            type: "list-item",
            label: formatMessage(messages.arterialConduitPlanned),
            value: formatMessageMap(greenLight_1.arterialConduitPlannedMessages, event.value.arterialConduitPlanned)
        },
        {
            type: "list-item",
            label: formatMessage(messages.estimatedBloodLoss),
            value: formatMessageMap(greenLight_1.estimatedBloodLossMessages, event.value.estimatedBloodLoss)
        },
        {
            type: "list-item",
            label: formatMessage(messages.cellSaverUsePlanned),
            value: formatMessageMap(greenLight_1.cellSaverUsePlannedMessages, event.value.cellSaverUsePlanned)
        },
        {
            type: "list-item",
            label: formatMessage(messages.venoVenousBypass),
            value: formatMessageMap(greenLight_1.venoVenousBypassMessages, event.value.venoVenousBypass)
        },
        {
            type: "list-item",
            label: formatMessage(messages.backupRecipient),
            value: formatMessageMap(greenLight_1.backupRecipientMessages, event.value.backupRecipient)
        },
        {
            type: "list-item",
            label: formatMessage(messages.immunosuppression),
            value: formatMessageMap(greenLight_1.immunosuppressionMessages, event.value.immunosuppression)
        }
    ];
    if (event.value.portalVeinThrombosisComment) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.portalVeinThrombosisComment),
            value: event.value.portalVeinThrombosisComment
        });
    }
    if (event.value.hepaticArterialAnatomyComment) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.hepaticArterialAnatomyComment),
            value: event.value.hepaticArterialAnatomyComment
        });
    }
    if (event.value.immunosuppressionOther) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.immunosuppressionOther),
            value: event.value.immunosuppressionOther
        });
    }
    if (event.value.otherTechnicalDifficulties) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.otherTechnicalDifficulties),
            value: event.value.otherTechnicalDifficulties
        });
    }
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        origin: event.origin,
        timestamp: event.timestamp,
        sid: event.sid,
        label: formatMessage(messages.greenLight),
        items
    };
}
